<div class="top-tracks-container">

  @if(store.isTopLoading()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <div class="">
    <table mat-table [dataSource]="dataSource">

      <!-- ID Column -->
      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef style="width: 20px"></th>
        <td mat-cell *matCellDef="let row; let index = index">
          <div class="row-index">
            {{index + 1}}.
          </div>

          <div class="row-action">
            <mat-icon class="track-icon"
                      (click)="play(index, row)"
                      [class.track-icon__current]="playerSource.currentTrack() && playerSource.currentTrack()?.id === row.id">play_circle</mat-icon>
          </div>



        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef > </th>
        <td mat-cell *matCellDef="let row">
          <div>
            <div class="track-title ellipsize">{{row.title}}</div>
            <div class="track-author ellipsize">{{row.artists}}</div>
          </div>

        </td>
      </ng-container>


      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef  style="width: 20px"></th>
        <td mat-cell *matCellDef="let row">
          <span class="material-symbols-outlined pointer download-icon" [class.disabled]="row.downloadsCount > 2 || store.downloadsLeft() < 1" (click)="download(row)">download</span>
        </td>
      </ng-container>


<!--      <tr mat-header-row *matHeaderRowDef="displayedColumns" style="border: none"></tr>-->
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="track-row" [ngClass]="{'row-current': playerSource.currentTrack() && playerSource.currentTrack()?.id === row.id,
       'previewed': row.previewed?.length > 0,
        'available': row.downloadsCount > 0 &&  row.downloadsCount < 3, 'fully-downloaded': row.downloadsCount > 2}"></tr>

    </table>
  </div>

</div>
